var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('business-form',{attrs:{"form-data":_vm.formData,"loading":_vm.isLoading},on:{"update:formData":function($event){_vm.formData=$event},"update:form-data":function($event){_vm.formData=$event},"submit":_vm.onSubmit,"cancel":_vm.onCancel}})}
var staticRenderFns = []

export { render, staticRenderFns }